import { useRouteNamespaces } from '@aikoa/i18n/react'
import { Stack, usePathname } from 'expo-router'
import { View } from 'react-native'
import AppHeader from '~/components/AppHeader'
import { useSession } from '~/components/user/SessionProvider'
import { getStackHeaderOptions } from '~/lib/headerConfig'
import { cn } from '~/lib/utils'

export default function FrontLayout() {
  useRouteNamespaces('(front)')

  const pathName = usePathname()
  const { session } = useSession()

  const isNarrowHeader = ['/feedback', '/onboarding', '/'].some((path) => pathName.startsWith(path))

  return (
    <View className={cn('my-2 flex-1', pathName === '/' && 'my-0')}>
      {pathName !== '/' && (
        <AppHeader
          className={cn('max-w-4xl', isNarrowHeader && 'max-w-xl')}
          showMenuButton={false}
        />
      )}
      <Stack screenOptions={getStackHeaderOptions()}>
        <Stack.Screen name="index" />
        <Stack.Screen name="privacy-policy" />
        <Stack.Screen name="terms-of-service" />
        <Stack.Screen name="cookie-policy" />
        <Stack.Screen name="dpa" />
        <Stack.Protected guard={!session}>
          <Stack.Screen name="login" />
        </Stack.Protected>
      </Stack>
    </View>
  )
}
